export default __webpack_public_path__ + "static/media/2008bf5384740befe9374c6c45d190501577112328621.1fbefda2.webp";